import React from "react";
import { Container } from "@mui/system";
import { Grid, Typography, Box } from "@mui/material";
import globals from "../globals";
import RedButton from "../components/redButton";

export default function SomethingWentWrongPage() {

  return (
    <Container>
      <Grid container justifyContent="space-evenly" alignItems="center" >
        <Grid item xs={10} sm={4}>
          <img src='something_went_wrong.webp' style={{ height: 300, width: 300 }}></img>
        </Grid>
        <Grid item textAlign={'center'} xs={10} sm={5}>
          <Typography sx={{ color: globals.colors.lightRed, fontSize: 40, fontWeight: 'bold' }}>Упс! Нещо се обърка…</Typography>
          <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold', mt: 4 }}>Извиняваме се за неудобството. Моля, опитайте отново след малко или се свържете с нас, ако проблемът продължава.</Typography>

          <Grid container justifyContent={'center'}>
            <RedButton text={"Към началото"} mTop={5} pX={4} href={'/'} />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}